module.exports = __webpack_public_path__ + "img/legend-gr.9f2f9a6b.svg";